import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MatTableDataSource} from '@angular/material/table';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    private event_id: string ="32An8FerileIhmvFBfUY";

    public dataSource: MatTableDataSource<any>;

    constructor (
        private db: AngularFirestore,
    ) { }

    selectTopics () {
        let array: any[] = [];
        return this.db.collection<any>('sbccv_event_topics', ref => ref
            .where('event_id', '==', this.event_id)
            .where('deleted', '==', true)
            .orderBy('date', 'asc')
            ).snapshotChanges()
            .subscribe((result) => {
                array = result.map(item => {
                    let entity: any = {};
                    entity = item.payload.doc.data()
                    entity.id = item.payload.doc.id;
                    return entity;
                });

                this.dataSource = new MatTableDataSource(array);
            })
    }

    selectActivities () {
        let array: any[] = [];
        return this.db.collection<any>('sbccv_event_activities', ref => ref
            .where('event_id', '==', this.event_id)
            .where('deleted', '==', true)
            .orderBy('date', 'asc')
            ).snapshotChanges()
            .subscribe((result) => {
                array = result.map(item => {
                    let entity: any = {};
                    entity = item.payload.doc.data()
                    entity.id = item.payload.doc.id;
                    return entity;
                });

                this.dataSource = new MatTableDataSource(array);
            })
    }

    selectDays () {
        let array: any[] = [];
        return this.db.collection<any>('sbccv_event_days', ref => ref
            .where('event_id', '==', this.event_id)
            .where('deleted', '==', true)
            .orderBy('date', 'asc')
            ).snapshotChanges()
            .subscribe((result) => {
                array = result.map(item => {
                    let entity: any = {};
                    entity = item.payload.doc.data()
                    entity.id = item.payload.doc.id;
                    return entity;
                });

                this.dataSource = new MatTableDataSource(array);
            })
    }


    selectAllEvents () {
        return this.db.collection<any>('sbccv_events', ref => ref
            .where('deleted', '==', false)
            ).snapshotChanges();
    }

    
    selectAllDays () {
        return this.db.collection<any>('sbccv_event_days', ref => ref
            .where('deleted', '==', false)
            ).snapshotChanges();
    }

    selectAllActivities () {
        return this.db.collection<any>('sbccv_event_activities', ref => ref
            .where('deleted', '==', false)
            ).snapshotChanges();
    }


    selectAllTopics () {
        return this.db.collection<any>('sbccv_event_topics', ref => ref
            .where('deleted', '==', false)
            ).snapshotChanges();
    }

    selectAllAgenda () {
        return this.db.collection<any>('sbccv_agenda', ref => ref
            ).snapshotChanges();
    }

    selectAllInvites () {
        return this.db.collection<any>('sbccv_invites', ref => ref
            ).snapshotChanges();
    }

    selectAllLetters () {
        return this.db.collection<any>('sbccv_letters', ref => ref
            ).snapshotChanges();
    }

    selectAllMembers () {
        return this.db.collection<any>('sbccv_members', ref => ref
            ).snapshotChanges();
    }

   

}
